import React, { useEffect, useState, useCallback } from "react";
import { useIntl } from "react-intl";
import { Form } from "antd";

import SelectItemWithLoad from "../selectItemWithLoad";
import NumberWithCurrency from "../numberWithCurrency";
import { loadMaxCodAmounts } from "../../../../modules/staticDataLoad";
import { defaultMaxCodAmoutInCzk } from "../../../consignment/servicesForm/cashOnDelivery";

const CashOnDeliveryItem = ({
  product,
  disabled,
  optional,
  skeleton,
  currencies,
  inlineLabel,
  cashOnDelivery,
  formItemLayout,
  onAmountChange,
  amountFieldName,
  onCurrencyChange,
  productCurrencies,
  currencyFieldName,
  getFieldDecorator,
}) => {
  const intl = useIntl();
  const [currenciesForCod, setCurrenciesForCod] = useState();
  useEffect(() => {
    const allowed =
      currencies &&
      currencies !== "e" &&
      productCurrencies &&
      productCurrencies.length > 0
        ? currencies.filter((c) => productCurrencies.includes(c.code))
        : currencies;
    if (!allowed || allowed === "e" || allowed.length === 0) {
      setCurrenciesForCod("e");
    } else {
      allowed && allowed.some((c) => c.forCashOnDelivery)
        ? setCurrenciesForCod(allowed.filter((c) => c.forCashOnDelivery))
        : allowed && allowed.some((c) => c.default)
        ? setCurrenciesForCod(allowed.filter((c) => c.default))
        : setCurrenciesForCod();
    }
  }, [currencies, productCurrencies]);

  const [codCurrency, setCodCurrency] = useState();
  useEffect(() => {
    cashOnDelivery &&
      cashOnDelivery.currency &&
      currenciesForCod &&
      currenciesForCod !== "e" &&
      setCodCurrency(
        currenciesForCod.find((c) => c === cashOnDelivery.currency.id)
      );
  }, [cashOnDelivery, currenciesForCod]);
  const handleCurrencyChange = useCallback(
    (currency) => {
      onCurrencyChange && onCurrencyChange(currency);
      setCodCurrency(currency);
    },
    [onCurrencyChange]
  );
  useEffect(() => {
    currenciesForCod &&
      currenciesForCod !== "e" &&
      (!codCurrency ||
        currenciesForCod.every((c) => c.id !== codCurrency.id)) &&
      handleCurrencyChange(currenciesForCod[0]);
  }, [currenciesForCod, codCurrency, handleCurrencyChange]);

  const [maxCodAmounts, setMaxCodAmounts] = useState();
  useEffect(
    () => loadMaxCodAmounts(product && product.id, setMaxCodAmounts),
    [product]
  );

  const [maxCodAmount, setMaxCodAmount] = useState(defaultMaxCodAmoutInCzk);
  useEffect(() => {
    if (maxCodAmounts && maxCodAmounts !== "e" && codCurrency) {
      const max = maxCodAmounts.find((m) => m.currency.id === codCurrency.id);
      setMaxCodAmount((max && max.maxValue) || defaultMaxCodAmoutInCzk);
    }
  }, [maxCodAmounts, codCurrency]);

  const form = (
    <NumberWithCurrency
      disabled={disabled}
      maxAmount={maxCodAmount}
      currencies={currenciesForCod}
      onInputChange={onAmountChange}
      formItemLayout={formItemLayout}
      label={
        inlineLabel &&
        intl.formatMessage({
          id: "consignment.codAmount",
          defaultMessage: "Hodnota dobírky",
        })
      }
      onSetCurrency={handleCurrencyChange}
      getFieldDecorator={getFieldDecorator}
      message={
        optional
          ? undefined
          : intl.formatMessage({
              id: "consignment.services.emptyCodAmount",
              defaultMessage: "Zadejte prosím hodnotu dobírky!",
            })
      }
      amountSpan={inlineLabel ? undefined : 9}
      amountOffset={inlineLabel ? undefined : 3}
      currencySpan={inlineLabel ? undefined : 12}
      amountFieldName={amountFieldName || "amount"}
      currencyFieldName={currencyFieldName || "currencyCod"}
      initialAmount={cashOnDelivery && cashOnDelivery.amount}
      initialCurrency={cashOnDelivery && cashOnDelivery.currencyId}
      precision={!codCurrency || codCurrency.roundValue ? undefined : 2}
    />
  );

  return (
    <SelectItemWithLoad
      skeleton={skeleton}
      options={currenciesForCod}
      errorMessage={intl.formatMessage({
        id: "consignment.services.emptyCodCurrencies",
        defaultMessage: "Nemáte povoleny žádné měny.",
      })}
    >
      {inlineLabel ? (
        form
      ) : (
        <Form.Item
          label={intl.formatMessage({
            id: "consignment.cashOnDelivery",
            defaultMessage: "Dobírka",
          })}
        >
          {form}
        </Form.Item>
      )}
    </SelectItemWithLoad>
  );
};

export default CashOnDeliveryItem;
